
/**
* js hp menu
*/
export function jsSubmenuInit(lazyLoadUpdateFn, isHomepage) {
    const menuLinksTop = document.querySelectorAll('.menu-link--top');
    const submenuItems = [];    
    menuLinksTop.forEach(menuItem => {
        if (isHomepage && menuItem.dataset.jsFor === 'sports') {
            menuItem.addEventListener('click', (e) => {
                window.scrollTo({top: 0, behavior: 'smooth'});
            });
        }
        menuItem.addEventListener('mouseenter', (e) => {
            const submenuLink = menuItem?.dataset?.submenuLink
            if (submenuLink) {
                let submenu = submenuItems.find(s => s.submenuLink === submenuLink)
                if (!submenu) {
                    fetch(submenuLink)
                    .then(async data => {
                        submenu = await data.json()
                        submenuItems.push({submenuLink, data: submenu})
                        Object.keys(submenu).forEach(submenuId => {
                            const element = document.getElementById(submenuId)
                            if (element) {
                                element.innerHTML = submenu[submenuId]
                            }
                        })
                        lazyLoadUpdateFn && lazyLoadUpdateFn()
                    })
                    .catch((e) => console.error(`error during fetch submenu: ${submenuLink}`, e))
                } else {
                    Object.keys(submenu.data).forEach(submenuId => {
                        const element = document.getElementById(submenuId)
                        if (element) {
                            element.innerHTML = submenu.data[submenuId]
                        }
                    })
                    lazyLoadUpdateFn && lazyLoadUpdateFn()
                }
            }
        })
    })
}
